import { CALL_API } from 'redux-api-middleware'
import { get } from 'utils/network'

export const searchSubject = (input) => {
  const query = {
    q: input,
    by: 'code',
  }
  const s = input.split(':')
  if (s.length > 1) {
    query.q = s[1]
    query.by = s[0].toLowerCase()
  }
  const request = get('/subjects/search', query)
  request.types = ['SUBJ_Q_REQ', 'SUBJ_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Subjects/actions.js